import Reason from './Reason';

export const Reasons = Object.freeze({
    checking_environment: new Reason(101, 'Checking Environment'),
    environment_checks_succeeded: new Reason(103, 'Environment Checks Succeeded'),
    webcam_access_given: new Reason(105, 'Webcam Access Given'),
    video_quality_check_successful: new Reason(108, 'Video Quality Check Successful'),
    webcam_selected_or_1_webcam: new Reason(121, 'Webcam Selected Or 1 Webcam'),
    camera_feeds_checked: new Reason(127, 'Camera Feeds Checked'),
    success_study_completed_results_submitted: new Reason(201, 'Success, study completed, results submitted'),
    connected_mediaserver: new Reason(202, 'Media server connected'),
    media_preloaded: new Reason(128, 'Media preloaded'),

    //warnings
    video_quality_check_failed: new Reason(300, 'Video Quality Check Failed'),
    denied_request_again_x_times: new Reason(301, 'Denied, Request Again X times'),
    failed_retry_again_x_times: new Reason(302, 'Failed, Retry Again X times'),

    //error
    no_webcam: new Reason(
        400,
        'No Webcam',
        'dc_error_no_webcams_detected_message',
        'dc_error_no_webcams_detected_hint'
    ),
    webcam_access_denied: new Reason(401, 'Webcam Access Denied', 'cam_denied_401'),
    low_lighting_conditions_for_bg: new Reason(402, 'Low lighting conditions for bg', 'add_light'),
    high_lighting_conditions_for_bg: new Reason(403, 'High lighting conditions for bg', 'remove_light'),
    cant_find_face: new Reason(404, "Can't find face", 'face_the_camera'),
    face_too_small: new Reason(405, 'Face too small', 'move_closer'),
    low_lighting_conditions_for_face: new Reason(406, 'Low lighting conditions for face', 'add_light'),
    highlighting_conditions_for_face: new Reason(407, 'Highlighting conditions for face', 'remove_light'),
    face_off_center: new Reason(408, 'Face off center', 'move_closer'),
    collection_aborted_by_user: new Reason(413, 'Collection Aborted By User', 'study_cancelled'),
    error_in_collection_or_presentation: new Reason(414, 'Error in Collection or Presentation'),
    preloading_media_failed: new Reason(416, 'Preloading Media Failed'),
    required_parameter_missing: new Reason(417, 'Required parameter missing'),
    webcam_select_timeout: new Reason(419, 'Webcam Select Timeout', 'select_camera_timeout'),
    no_webcam_activites: new Reason(421, 'No Webcam Activities', 'cam_busy'),
    cant_connect_mediaserver: new Reason(422, "Can't Connect Mediaserver", 'error_connection_failed'),
    cant_load_stimulus: new Reason(423, "Can't Load Stimulus"),
    webcam_access_timeout: new Reason(
        424,
        "Sorry, the session timed out because you didn't give access to a webcam in {TIMEOUT} seconds. Please refresh the page to start a new session!",
        'webcam_access_timeout'
    ),
    mediaserver_connection_lost: new Reason(425, 'Mediaserver connection lost.', 'mediaserver_connection_lost'),
    weak_connection: new Reason(426, 'Internet connection is too slow.', 'weak_connection'),
    face_duplication: new Reason(427, 'Face duplication detected .', 'face_duplication'),

    //system_error
    error_starting_session: new Reason(500, 'Error starting session (ie the startcollection fails)', 'error'),
    error_saving_session: new Reason(501, 'Error saving session (ie the posting of session data fails)', 'error'),
    error_uncaught_exception: new Reason(502, 'Uncaught Exception', 'error'),

    declined_to_proceed_after_a_webcam_was_not_detected: new Reason(
        601,
        'Declined to proceed after a webcam was not detected',
        'decline'
    ),

    // todo: These are the reasons, that do not have constant id in different configurations (db). Negative ids is a hack.
    cookies_disabled: new Reason(
        -1000,
        "You're required to have Cookies enabled to participate in this study. Please enable Cookies and try again.<br />",
        'cookies_disabled'
    ),
    incompatible_browser: new Reason(
        -1001,
        'Your browser does not meet the minimum requirements for the technology we use.',
        'dc_error_browser_not_capable_message',
        'dc_error_browser_not_capable_hint'
    ),
    desktop_browser: new Reason(
        -1002,
        'This survey does not support desktop devices.',
        'dc_error_desktop_browser_message',
        'dc_error_desktop_browser_hint'
    ),
    tablet_browser: new Reason(
        -1002,
        'This survey does not support tablet devices.',
        'dc_error_tablet_browser_message',
        'dc_error_tablet_browser_hint'
    ),
    mobile_browser: new Reason(
        -1002,
        'This survey does not support mobile devices.',
        'dc_error_mobile_browser_message',
        'dc_error_mobile_browser_hint'
    ),
    ajax_timeout: new Reason(-1005, 'Ajax request timeout', 'error_connection_closed'),
    ajax_no_connection: new Reason(-1006, 'Ajax request failed with network error', 'error_connection_closed'),
    error_js: new Reason(-1011, 'Javascript exception occured ', 'error_js'),
    ios_webview: new Reason(
        -1013,
        'Embedded WebView is not supported.',
        'dc_error_ios_webview_message',
        'dc_error_ios_webview_hint'
    ),
    blacklisted: new Reason(
        -1013,
        'Embedded WebView is not supported.',
        'dc_error_ios_webview_message',
        'dc_error_ios_webview_hint'
    ),
    ios_browser_not_capable: new Reason(
        -1014,
        'Your browser does not meet the minimum requirements for the technology we use.',
        'dc_error_ios_browser_not_capable_message',
        'dc_error_ios_browser_not_capable_hint'
    ),
    other_error: new Reason(-1015, '', 'dc_error_other_error_message', 'dc_error_other_error_hint'),
    cookie_consent_denied: new Reason(
        -1015,
        'Your browser does not meet the minimum requirements for the technology we use.',
        'dc_cookie_consent_denied_error_message',
        'dc_cookie_consent_denied_error_hint'
    ),
    face_duplication: new Reason(
        -1016,
        'Unfortunately, you can’t participate in this research experiment more than once.Thank you for your contribution so far, you are always welcome to take part in other exercises.',
        'dc_face_duplication_error_message',
        'dc_face_duplication_error_hint'
    )
});
